import type { AriaRole, ElementType, ReactNode } from "react";
import cs from "classnames";

import { Button } from "@braintrust/braintrust-ui-components";
import { handleKeyDownConfirm } from "@js/utils/keyboard";

type InteractiveTagProps = {
  className?: string;
  tag?: ElementType;
  children: ReactNode;
  role?: AriaRole;
  tabIndex?: number;
  onClick: () => void;
  style?: React.CSSProperties;
};

export const InteractiveTag = ({
  children,
  tag,
  onClick,
  className,
  ...otherProps
}: InteractiveTagProps) => {
  const Tag = tag ?? Button;

  return (
    <Tag
      className={cs("pointer", { className })}
      onClick={onClick}
      role="button"
      onKeyDown={handleKeyDownConfirm(onClick)}
      variant="transparent"
      fontWeight={400}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};
